import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext.tsx';
import { ProtectedRoute } from './auth/ProtectedRoute.tsx';
import { Layout } from './components/layout/Layout.tsx';

// Public pages
import { LandingPage } from './pages/public/LandingPage.tsx';
import { LoginPage } from './pages/public/LoginPage.tsx';
import { ContactPage } from './pages/public/ContactPage.tsx';
import { NotFoundPage } from './pages/public/NotFoundPage.tsx';

// Member pages
import { PortalPage } from './pages/member/PortalPage.tsx';

// Admin pages
import { TrafficPage } from './pages/admin/TrafficPage.tsx';
import { ClientsPage } from './pages/admin/ClientsPage.tsx';
import { ClientDetailPage } from './pages/admin/ClientDetailPage.tsx';
import { ProjectDetailPage } from './pages/admin/ProjectDetailPage.tsx';
import { ContractorsPage } from './pages/admin/ContractorsPage.tsx';
import { ContractorDetailPage } from './pages/admin/ContractorDetailPage.tsx';
import { ProductsPage } from './pages/admin/ProductsPage.tsx';
import { DashboardPage } from './pages/admin/DashboardPage.tsx';
import { FinancialOverviewPage } from './pages/admin/FinancialOverviewPage.tsx';
import { GuidesPage } from './pages/admin/GuidesPage.tsx';
import { SecurityPage } from './pages/admin/SecurityPage.tsx';

export default function App() {
  return (
    <AuthProvider>
      <Layout>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Member routes */}
          <Route
            path="/portal"
            element={
              <ProtectedRoute>
                <PortalPage />
              </ProtectedRoute>
            }
          />

          {/* Admin routes */}
          <Route
            path="/admin/traffic"
            element={
              <ProtectedRoute allowedGroups={['Admins']}>
                <TrafficPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/projects"
            element={
              <ProtectedRoute allowedGroups={['Admins']}>
                <ClientsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/projects/clients/:clientId"
            element={
              <ProtectedRoute allowedGroups={['Admins']}>
                <ClientDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/projects/clients/:clientId/:projectId"
            element={
              <ProtectedRoute allowedGroups={['Admins']}>
                <ProjectDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/contractors"
            element={
              <ProtectedRoute allowedGroups={['Admins']}>
                <ContractorsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/contractors/:contractorId"
            element={
              <ProtectedRoute allowedGroups={['Admins']}>
                <ContractorDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/products"
            element={
              <ProtectedRoute allowedGroups={['Admins']}>
                <ProductsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute allowedGroups={['Admins']}>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/financials"
            element={
              <ProtectedRoute allowedGroups={['Admins']}>
                <FinancialOverviewPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/guides"
            element={
              <ProtectedRoute allowedGroups={['Admins']}>
                <GuidesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/security"
            element={
              <ProtectedRoute allowedGroups={['Admins']}>
                <SecurityPage />
              </ProtectedRoute>
            }
          />

          {/* Fallback */}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Layout>
    </AuthProvider>
  );
}
